//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"AngleToleranceData",1,0],[0,"C0KnotLineColor",1,0],[0,"C0KnotLineFont",1,0],[0,"C0KnotUseBodyColor",1,0],[0,"C0KnotUseBodyFont",1,0],[0,"C1KnotLineColor",1,0],[0,"C1KnotLineFont",1,0],[0,"C1KnotUseBodyColor",1,0],[0,"C1KnotUseBodyFont",1,0],[0,"C2KnotLineColor",1,0],[0,"C2KnotLineFont",1,0],[0,"C2KnotUseBodyColor",1,0],[0,"C2KnotUseBodyFont",1,0],[0,"ConvertAnalyticToConvergentAngularTolerance",1,0],[0,"ConvertAnalyticToConvergentDistanceTolerance",1,0],[0,"ConvertAnalyticToConvergentMaximumChordLength",1,0],[0,"ConvertAnalyticToConvergentMaximumFacetWidth",1,0],[0,"CurveCurvatureDisplay",1,0],[0,"CurveCurvatureShowCap",1,0],[0,"CurveCurvatureStyle",1,0],[0,"CutViewUpdateDelayed",1,0],[0,"Density",1,0],[0,"DensityUnit",1,0],[0,"DisplayCurveCurvatureOutside",1,0],[0,"DistanceToleranceData",1,0],[0,"GridLineColor",1,0],[0,"GridLineFont",1,0],[0,"GridLinesUCount",1,0],[0,"GridLinesVCount",1,0],[0,"GridResolution",1,0],[0,"GridUseBodyColor",1,0],[0,"GridUseBodyFont",1,0],[0,"MaxChordLengthOption",1,0],[0,"MaxFacetWidthOption",1,0],[0,"OptimizeCurve",1,0],[0,"OptimizeCurveAngleToleranceFactor",1,0],[0,"OptimizeCurveDistanceToleranceFactor",1,0],[0,"OptimizeCurveToleranceFactor",1,1],[0,"TreatOneDegreeBsplineAsPolyline",1,0]],[[[],"GetHistoryMode",{R_:{history:''}},0,0],[[],"SetHistoryMode",{},0,0],[[],"SetHistoryFreeMode",{},0,0],[[],"GetKeepLocalFeatures",{R_:{keepLocalFeatures:''}},0,0],[["keepLocalFeatures"],"SetKeepLocalFeatures",{},1,0],[[],"GetIsSavedByWebApp",{R_:{isSavedByWebApp:''}},0,0],[["isSavedByWebApp"],"SetIsSavedByWebApp",{},1,0]],[]];
SPLM.Preferences.PartModeling = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartModeling";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartModeling.DensityUnitType = Object.freeze({
    "LbPerCuInch" : "LbPerCuInch", "LbPerCuFeet" : "LbPerCuFeet", "GmPerCuCm" : "GmPerCuCm", "KgPerCuMeter" : "KgPerCuMeter"});

SPLM.Preferences.PartModeling.CurveCurvatureDisplayType = Object.freeze({
    "Comb" : "Comb", "RadiusOfComb" : "RadiusOfComb"});

SPLM.Preferences.PartModeling.GridResolutionType = Object.freeze({
    "None" : "None", "Coarse" : "Coarse", "Standard" : "Standard", "Fine" : "Fine", "ExtraFine" : "ExtraFine", "UltraFine" : "UltraFine"});

SPLM.Preferences.PartModeling.GridKnotLineFontType = Object.freeze({
    "Solid" : "Solid", "Dashed" : "Dashed", "Phantom" : "Phantom", "Centerline" : "Centerline", "Dotted" : "Dotted", "LongDashed" : "LongDashed", "DottedDashed" : "DottedDashed", "Eight" : "Eight", "Nine" : "Nine", "Ten" : "Ten", "Eleven" : "Eleven"});

export default SPLM;